import React, { Fragment } from "react";
import Input from "components/General/Form/Input";
import TextTheme from "components/General/Text/TextTheme";
import Add from "@material-ui/icons/Add";
import RoundedButton from "components/General/Form/CustomButton/RoundedButton";
import DeleteButton from "components/General/Form/CustomButton/DeleteButton";

class UnregisteredFriendsInvite extends React.Component {
  render() {
    return (
      <Fragment>
        <hr />
        <div>
          <TextTheme
            message={this.props.message}
            className="mt-15 text_small text_black"
          />
        </div>
        <table className="unregistered-user-list">
          <tbody>
            {this.props.unregisteredUser.map((user, index) => {
              return (
                <tr key={index}>
                  <td>
                    <Input
                      type="text"
                      width="100%"
                      autoComplete="chrome-off"
                      placeholder="Email*"
                      handleChange={(e) =>
                        this.props.unregisteredUserEmailChange(e, index)
                      }
                      // onBlur={this.props.unregisteredUserEmailValidate(index)}
                      value={user.email_address}
                    />
                    <span className="status">{user.status}</span>
                  </td>
                  <td>
                    {index > 0 ? (
                      <DeleteButton
                        handleOnClick={(e) =>
                          this.props.unregisteredUserDeleteClick(e, index)
                        }
                      />
                    ) : (
                      null
                    )} 
                  </td>
                  <td>
                    <TextTheme
                      message={user.issue}
                      className="text_small text_red"
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <div style={{ width: "100%", marginTop: "5px" }}>
          <RoundedButton
            startIcon={<Add style={{ fontSize: 20, color: '#fff' }} />}
            handleOnClick={this.props.unregisteredUserAddMoreClick}
            title="ADD MORE&nbsp;"
            disabled={this.props.disabled}
            textThemeClassName="text_small text_white"
            buttonClassName="background_dark_orange"
            borderRadius="6px"
          />
          <TextTheme
            message={this.props.unregisteredUserIssue}
            className="mt-15 text_small text_red"
          />
        </div>
        {/* <div style={{ marginTop: "50px" }}></div> */}
      </Fragment>
    );
  }
}
export default UnregisteredFriendsInvite;
